import { useState } from 'react';
import { 
  Grid, Container, Typography, Button
} from '@mui/material';
import { Navigate, useNavigate } from 'react-router-dom';

import StepsForgotPass from '../../components/auth/StepsForgotPass';
import FormForgotPass from '../../components/auth/FormForgotPass';
import FormForgetPass2 from '../../components/auth/FormForgetPass2';
import FormForgetPass3 from '../../components/auth/FormForgetPass3';
import CrearPass from '../../components/auth/CrearPass';

import { useSelector } from 'react-redux';

const ForgotPass = () => {
  const navigate = useNavigate();
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  const user = useSelector(state => state.user);

  const [value, setValue] = useState('celular');
  const [pasos, setPasos] = useState(1);
  const [data, setData] = useState({
    tel: '',
    prefijo: '52',
    email: '',
    codigo: '',  //el codigo que se genera por email
    userId: ''
  });
  const [codigo, setCodigo] = useState(''); // el codigo que ingresa el usuario

  //Redirect
  if(isAuthenticated){
    return <Navigate to="/" />
  }

  /******Olvidar contraseña**********/
  const [exito, setExito] = useState(false);
  const img = exito ? "/Sticker.png" : "/Vector.png";
  const title = exito ? "Contraseña actualizada" : "Ocurrió un error";
  const subTitle = exito ? "Su contraseña ha sido cambiada con éxito." : "¡Upps! ha ocurrido un error intenta de nuevo.";

  return (
    <Container component="main" maxWidth="lg">
      {
        pasos === 5 ? (
          <Grid className="general" container size={12}>
            <Grid className="status" container direction="column" alignItems="center" justifyContent="center">
              <img width="150" src={img} alt="Estatus" />
            </Grid>
            <Grid container direction="column" alignItems="center" justifyContent="center">
              <Typography variant="h4">{title}</Typography>
              <Typography variant="h5">{subTitle}</Typography>
            </Grid>
            <Grid size={6} sx={{mt: 3}}>
              <Button
                type="button"
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => navigate('/login')}
              >
                Entrar
              </Button>
            </Grid>
          </Grid>
        ) : (
          <Grid className="container-steps" container spacing={{ lg: 3}}>
            <StepsForgotPass
              pasos={pasos}
            />
            <Grid className="form-steps" size={{xs: 12, lg: 6}}>
              {
                pasos === 1 ? (
                  <FormForgotPass
                    value={value}
                    setPasos={setPasos}
                    setValue={setValue}
                    navigate={navigate}
                  />
                ) : pasos === 2 ? (
                  <FormForgetPass2
                    type={value}
                    data={data}
                    setData={setData}
                    setPasos={setPasos}
                    navigate={navigate}
                  />
                ) : pasos === 3 ? (
                  <FormForgetPass3
                    type={value}
                    codigo={codigo}
                    data={data}
                    setData={setData}
                    setPasos={setPasos}
                    setCodigo={setCodigo}
                  />
                ) : pasos === 4 && (
                  <CrearPass
                    navigate={navigate}
                    setPasos={setPasos}
                    setExito={setExito}
                    user={user}
                    userId={data.userId}
                    token={data.token}
                  />
                )
              }
            </Grid>
          </Grid>
        )
      }
    </Container>
  );
}

export default ForgotPass;